import Typography from '@navi/web-ui/lib/primitives/Typography';
import { useEffect, useState } from 'react';
import styles from './AgencyLeaderboard.module.scss';
import LinearProgressBar from './LinearProgressBar';
import cx from 'classnames';
import { PerformanceBar } from './PerformanceBar';
import { EMICollectionEfficiencyProps } from './interfaces';

const EMICollectionEfficiency = (props: EMICollectionEfficiencyProps) => {
  const {
    currentEfficiency,
    currentTarget,
    targetAchievementPercent,
    maxEfficiency,
    currMonthAndYear
  } = props;
  const [progress, setProgress] = useState(0);

  const efficiencyWidth = (100 * currentEfficiency) / maxEfficiency;
  const currentEfficiencyWidth = efficiencyWidth > 100 ? 100 : efficiencyWidth;
  useEffect(() => {
    currentEfficiency && setProgress(currentEfficiencyWidth);
  }, []);

  return (
    <div className={cx(styles.performanceContainer, 'flex flex-row px-3 py-3')}>
      <div className="flex flex-col w-2/3">
        <Typography
          variant="p5"
          className="flex text-[var(--grayscale-1)] font-semibold text-sm mb-3"
        >
          {currMonthAndYear}
        </Typography>
        <Typography variant="p5" className="flex text-[var(--grayscale-2)] text-sm mb-2">
          EMI Collection Efficiency (%)
        </Typography>
        <div className="flex w-full justify-end mb-6 translate-x-5">
          <div className="flex flex-col">
            <Typography variant="p5" className="flex text-[var(--grayscale-2)] text-xs">
              Target
            </Typography>
            <Typography
              variant="p5"
              className="flex text-[var(--grayscale-1)] text-base justify-center"
            >{`${currentTarget ?? '--'}`}</Typography>
          </div>
        </div>
        <LinearProgressBar value={progress} />
        <div className="flex w-full mt-7 -translate-x-11" style={{ marginLeft: `${progress}%` }}>
          <div className="flex flex-col">
            <Typography variant="p5" className="flex text-[var(--grayscale-2)] text-xs">
              Current Efficiency
            </Typography>
            <Typography
              variant="p5"
              className="flex text-[var(--grayscale-1)] text-base justify-center"
            >{`${currentEfficiency ?? '--'}`}</Typography>
          </div>
        </div>
        <div className="flex w-full justify-end mt-3">
          <div className="flex flex-col">
            <Typography variant="p5" className="flex text-[var(--grayscale-2)] text-sm">
              Target Achievement
            </Typography>
            <div className="flex flex-row items-baseline justify-center">
              <Typography variant="p5" className="mr-2 text-base text-[var(--grayscale-2)]">
                {currentEfficiency} / {currentTarget} =
              </Typography>
              <Typography variant="p3" className="text-xl font-bold">
                {targetAchievementPercent}%
              </Typography>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col w-1/3 border-l border-dashed border-[var(--navigation-blue-c2)] border-t-0 border-r-0 border-b-0 ml-16 items-center">
        <Typography className="text-sm text-[var(--grayscale-2)] mb-3" variant="p4">
          Performance Levels
        </Typography>
        <PerformanceBar />
      </div>
    </div>
  );
};

export default EMICollectionEfficiency;
